var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFileText(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "github"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M5.24964 12.8338V10.5003C5.2088 10.1386 5.23797 9.77106 5.33714 9.42103C5.43632 9.071 5.60549 8.74431 5.83301 8.45845C4.08291 8.45845 2.33281 7.29169 2.33281 5.24986C2.28525 4.52226 2.49141 3.80068 2.91618 3.20803C2.74117 2.53714 2.74117 1.83709 2.91618 1.1662C2.91618 1.1662 3.49954 1.1662 4.66627 2.04127C6.20636 1.74958 7.79311 1.74958 9.3332 2.04127C10.4999 1.1662 11.0833 1.1662 11.0833 1.1662C11.2466 1.83709 11.2466 2.53714 11.0833 3.20803C11.5092 3.80308 11.7133 4.52064 11.6667 5.24986C11.6667 7.29169 9.91657 8.45845 8.16647 8.45845C8.62145 9.03607 8.83099 9.76947 8.74983 10.5003V12.8338M5.24964 10.5003C2.61866 11.667 2.33293 9.33352 1.1662 9.33352",
    stroke: "#60A5FA",
    strokeWidth: 2,
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileText);
export default __webpack_public_path__ + "static/media/file-text.44c9790c789d6c87ca58a4c2d8af24ac.svg";
export { ForwardRef as ReactComponent };